export const apiUrl = "https://api.nail-ve.com";
// export const apiUrl = "https://7l60bxbl-4001.inc1.devtunnels.ms";
//  Live 2
export const s3Url = "https://d14dtfcg3aa6m.cloudfront.net";
export const s3BucketUrl = "https://nailve-bucket.s3.eu-north-1.amazonaws.com";

export const imageUrl = (url) => {
  const result = url?.indexOf("http"); // Check if URL starts with 'http'
  const imageRenderUrl = result == -1 ? `${s3BucketUrl}/${url}` : url; // Add S3 prefix if relative URL
  return imageRenderUrl;
};
export const mediaUrl = (url) => {
  const result = url?.indexOf("http"); // Check if URL starts with 'http'
  const imageRenderUrl = result == -1 ? `${s3BucketUrl}/${url}` : url; // Add S3 prefix if relative URL
  return imageRenderUrl;
};

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const roleRegex = /^[A-Za-z\s]*$/;
